import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { Scale } from "./MyHelpers";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope } from "./ScreenProtocol";

export class JackpotDisplayDiamodPotPlayCity extends JackpotDisplayDiamondPotStep {
	
	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.logGroup.Add("JackpotDisplayDiamodPotPlayCity");
		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayDiamodPotPlayCity");
		this.resid = params.resid.Add("JackpotDisplayDiamodPotPlayCity");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayDiamodPotPlayCity");		
		this.TitleContainer.style.height = Scale.Hpx(420);
	}

	
	public override TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "jackpot_anims/DiamondPotPlayCity/DiamondPotPlayCity_Title", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public override TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		super.TitleLoaded(resourceManager);
		this.titleSpriteAnim.View().style.left= Scale.Xpx(-100);
		this.titleSpriteAnim.Scale(1.1);
		
	}
}
